import { render, staticRenderFns } from "./SosMenuLink.vue?vue&type=template&id=247fd62a&scoped=true"
import script from "./SosMenuLink.vue?vue&type=script&lang=js"
export * from "./SosMenuLink.vue?vue&type=script&lang=js"
import style0 from "./SosMenuLink.vue?vue&type=style&index=0&id=247fd62a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247fd62a",
  null
  
)

export default component.exports